
import axios from 'axios'

const state = {
    countries: {},
    region:{},
    uploading_file:{},
    district:{},
    regions: {},
    districts: {},
    mfies: {},
    clinics: {},
    drug_companies: {},
    mnns: {},
    drug_types: {},
    ips_protections: [],
    ips_features: [],
    helpers_loading: false,
    period_types: [
        // {
        //     id: 1,
        //     title: "Minutlik",
        //     value: 'price_minute'
        // },
        {
            id: 2,
            title: "Soatlik",
            value: 'price_hourly'
        },
        {
            id: 3,
            title: "Kunlik",
            value: 'price_daily'
        },
        {
            id: 4,
            title: "Oylik",
            value: 'price'
        },
    ]
}

const getters = {
    period_types: state => state.period_types,
    countries: state => state.countries,
    region: state => state.region,
    uploading_file: state => state.uploading_file,
    district: state => state.district,
    mfies: state => state.mfies,
    regions: state => state.regions,
    districts: state => state.districts,
    clinics: state => state.clinics,
    drug_companies: state => state.drug_companies,
    drug_types: state => state.drug_types,
    mnns: state => state.mnns,
    helpers_loading: state => state.helpers_loading,
    ips_protections: state => state.ips_protections,
    ips_features: state => state.ips_features,
}

const mutations = {
    setCountries(state, countries) {
        state.countries = countries
    },
    setPeriodTypes(state, period_types){
        state.period_types = period_types
    },
    setRegions(state, regions) {
        state.regions = regions
    },
    setUploadingFile(state, uploading_file) {
        state.uploading_file = uploading_file
    },
    setDistricts(state, districts) {
        state.districts = districts
    },
    setIpsProtections(state, ips_protections) {
        state.ips_protections = ips_protections
    },
    setIpsFeatures(state, ips_features) {
        state.ips_features = ips_features
    },
    setMfies(state, mfies) {
        state.mfies = mfies
    },
    setClinics(state, clinics) {
        state.clinics = clinics
    },
    setDrugCompanies(state, drug_companies) {
        state.drug_companies = drug_companies
    },
    setDrugTypes(state, drug_types) {
        state.drug_types = drug_types
    },
    setHelpersLoading(state, helpers_loading) {
        state.helpers_loading = helpers_loading
    },
    setRegion(state, region) {
        state.region = region
    },
    setDistrict(state, district) {
        state.district = district
    },
    setMnns(state, mnns) {
        state.mnns = mnns
    }
}

const actions = {
    getRegions({commit}, params) {
        commit('setHelpersLoading', true)
        axios.get('/api/regions', {params})
            .then(response => {
                commit('setRegions', response.data)
                commit('setHelpersLoading', false)
            })
    },
    getIpsProjections({commit}, params) {
        commit('setHelpersLoading', true)
        axios.get(`/api/firewalls/${params.project_id}/ips-protections`, {params})
            .then(response => {
                commit('setIpsProtections', response.data?.data ?? [])
                commit('setHelpersLoading', false)
            })
    },
    getIpsFeatures({commit}, params) {
        commit('setHelpersLoading', true)
        axios.get(`/api/firewalls/${params.project_id}/ips-features`, {params})
            .then(response => {
                commit('setIpsFeatures', response.data?.data ?? [])
                commit('setHelpersLoading', false)
            })
    },
    async getUploadingFile({commit}, id){
        axios.get('/api/drug-provider-files/' + id + '/show',)
            .then(response => {
                commit('setUploadingFile', response.data?.data)
            })
    },
    async getDistrictsByRegion({commit}, id) {
        commit('setHelpersLoading', true)
        axios.get('/api/districts/' + id + '/by-region-code',)
            .then(response => {
                commit('setHelpersLoading', false)
                commit('setDistricts', response.data)
            })
    },
    async getMfiesByDistrict({commit}, id) {
        commit('setHelpersLoading', true)
        axios.get('/api/mfies/' + id + '/by-district-id',)
            .then(response => {
                commit('setHelpersLoading', false)
                commit('setMfies', response.data)
            })
    },
    getClinics({commit}, params) {
        commit('setHelpersLoading', true)
        axios.get('/api/clinics', {params})
            .then(response => {
                commit('setHelpersLoading', false)
                commit('setClinics', response.data)
            })
    },
    getDrugCompanies({commit}, params) {
        commit('setHelpersLoading', true)
        axios.get('/api/drug-companies', {params})
            .then(response => {
                commit('setHelpersLoading', false)
                commit('setDrugCompanies', response.data)
            })
    },
    getDrugTypes({commit}, params) {
        commit('setHelpersLoading', true)
        axios.get('/api/drug-types', {params})
            .then(response => {
                commit('setHelpersLoading', false)
                commit('setDrugTypes', response.data)
            })
    },
    getCountries({commit}, params) {
        commit('setHelpersLoading', true)
        axios.get('/api/countries', {params})
            .then(response => {
                commit('setHelpersLoading', false)
                commit('setCountries', response.data?.data)
            })
    },
    getMnns({commit}, params) {
        commit('setHelpersLoading', true)
        axios.get('/api/mnns', {params})
            .then(response => {
                commit('setHelpersLoading', false)
                commit('setMnns', response.data)
            })
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}